<!-- Inspired by https://github.com/BiYuqi/vue-intersection-observer -->
<template>
    <InViewportSlotWrapper ref="slot">
      <slot :inViewport="inViewport">
        <div></div> <!-- Fallback div -->
      </slot>
    </InViewportSlotWrapper>
</template>
<script>
import getScrollParent from '@/utils/getScrollParent';
import InViewportSlotWrapper from './InViewportSlotWrapper.vue';

export default {
  components: { InViewportSlotWrapper },
  name: "observer",
  data() {
    return {
      observer: null,
      inViewport: false, // True when content is in viewport, false otherwise.
    };
  },
  emits: ["enter", "leave"],
  props: {
    root: {
      type: [HTMLElement, window],
      default: null
    },
    rootMargin: {
      type: [String, Number],
      default: "50px"
    },
    threshold: {
      type: [Array, Number],
      default: 0
    },
  },
  computed: {
    el () {
      return this.$refs.slot.$el.nextElementSibling;
    },
  },
  methods: {
    unobserve() {
      this.observer.disconnect();
    },
  },
  mounted() {
    let root = this.root || getScrollParent(this.el);

    const options = {
      root,
      rootMargin: this.rootMargin,
      threshold: this.threshold
    };
    this.observer = new IntersectionObserver(entries => {
      this.inViewport = entries[0].isIntersecting;

      if (entries[0].isIntersecting) {
        this.$emit("enter", entries[0]);
      } else {
        this.$emit("leave", entries[0]);
      }
    }, options);

    this.observer.observe(this.el);
  },
  beforeUnmount() {
    if (this.observer) {
      this.unobserve();
      this.observer = null;
    }
  },
};
</script>